export const getDeltaRevenuePendingOrdersURL = (tab, page, search = '') => {
  return `finance/delta-revenue-capturing/?page=${page}&tab=${tab}${search}`;
};

export const getDeltaRevenueUpdatedOrdersURL = () => {
  return `finance/delta-revenue-capturing/`; /* ?page=1&tab=pending'  */
};

export const saveDeltaOrderURL = () => {
  return `finance/delta-revenue-capturing/`; /* ?page=1&tab=pending'  */
};
export const saveUpdatedDeltaOrderURL = () => {
  return `finance/delta-revenue-capturing/update/`; /* ?page=1&tab=pending'  */
};

export const addDeltaOrderRemarkURL = (orderId) => {
  return `finance/delta-revenue-capturing/add-remarks/`;
};

export const getSourceDestinationDropdownsURL = (customer_ids) => {
  return `finance/delta-revenue-capturing/initial-filter-data/?customer_id=${customer_ids}`;
};

export const fetchBFAMappingURL = (page, search = '') => {
  return `/booking/delta-branch-bfa-mapping?page=${page}${search}`;
};

export const saveBFAMappingURL = (id) => {
  return `/booking/delta-branch-bfa-mapping`;
};
